import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import { LangProvider } from "@/context/LangContext";
import { SiteDataProvider } from "@/context/SiteDataContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Awards } from "@/components/Awards";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Studio } from "@/components/Studio";
import { Gallery } from "@/components/Gallery";
import { ReviewsSection } from "@/components/ReviewsSection";
import { Visit } from "@/components/Visit";
import { Footer } from "@/components/Footer";
import Admin from "@/pages/Admin";
import Products from "@/pages/Products";
import Reviews from "@/pages/Reviews";

function PublicSite() {
  return (
    <SmoothScroll>
      <div className="App min-h-screen bg-[#0C0806] text-[#F5ECDA] antialiased">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Awards />
          <Manifesto />
          <Services />
          <Gallery />
          <Studio />
          <ReviewsSection />
          <Visit />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}

function App() {
  return (
    <LangProvider>
      <SiteDataProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicSite />} />
              <Route path="/products" element={<Products />} />
              <Route path="/avis" element={<Reviews />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
        </AdminAuthProvider>
      </SiteDataProvider>
    </LangProvider>
  );
}

export default App;
